import apiClient from '../ApiClient';

export const deleteReview = async (id: number): Promise<any> => {
  const res = await apiClient.delete(`reviews/${id}`);

  return res.data;
};